<template>
  <transaction-list
    :transactionService = transactionService
    :productService = productService
    :locationService = locationService
    :showCost = showCost
  ></transaction-list>
</template>
<script>
  import TransactionList from '@/components/Common/Transaction/TransactionList'
  import {mapGetters} from 'vuex'

  export default {
    components: {
      TransactionList,
    },
    props: {
      productService: Object,
      transactionService: Object,
      locationService: Object,
    },

    computed: {
      ...mapGetters('acl', [
        'matchRoles'
      ]),

      showCost () {
        return this.matchRoles(['machine_operation'])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Transactions/Overview.vue